/**
 * Authenticated landing.
 *
 * Currently the Clients screen inside the app shell. As Events, Sponsors and
 * the Library land, this becomes a router rather than a single page.
 */

import AppShell from '../components/AppShell.tsx';
import Clients from './Clients.tsx';

export default function Home() {
  return (
    <AppShell active="clients" context="All clients · platform overview">
      <Clients />
    </AppShell>
  );
}
